import { reactive } from "vue";

/**
 * Errores de validación por campo, para enlazar a `:error-messages`.
 *
 * Es la mitad que hace útil el manejo de un 422: `BancoApiError.fieldErrors()`
 * devuelve `{ pin: ["length must be between 0 and 4"] }` y esto lo pone bajo el
 * input correspondiente, en vez de dejar al usuario con un "Ocurrió un error"
 * sin pista de qué corregir.
 */
export interface FormErrors {
  /** Mensajes del campo, o [] si no tiene. Para `:error-messages`. */
  for(field: string): string[];
  /** Reemplaza todos los errores, normalmente con lo que dio fieldErrors(). */
  set(errors: Record<string, string[]>): void;
  /** Limpia un campo; se llama al editarlo. */
  clear(field: string): void;
  /** Limpia todo; se llama antes de reenviar. */
  reset(): void;
  /** true si hay algún error pendiente. */
  readonly any: boolean;
}

export function useFormErrors(): FormErrors {
  const state = reactive<{ errors: Record<string, string[]> }>({ errors: {} });

  return {
    for(field: string) {
      return state.errors[field] ?? [];
    },
    set(errors: Record<string, string[]>) {
      state.errors = { ...errors };
    },
    clear(field: string) {
      if (field in state.errors) {
        const next = { ...state.errors };
        delete next[field];
        state.errors = next;
      }
    },
    reset() {
      state.errors = {};
    },
    get any() {
      return Object.keys(state.errors).length > 0;
    },
  };
}
